import * as React from 'react'

import { cn } from '@/lib/utils'
import { useContrastedBackground } from 'app/frontend/base/components/Card'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  const background = useContrastedBackground()

  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-md border px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        background,
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
